import { rest } from 'msw';
import { getConfig } from 'shared/config';
import { mySubsMock } from '.';

const customersAPI = `${getConfig().microServices?.host}/customers`;

export const handlers = [
  rest.get(`${customersAPI}/my/subscriptions`, (req, res, ctx) => {
    return res(ctx.json(mySubsMock));
  }),
];
